export default __webpack_public_path__ + "ins-association.svg";